module.exports = "images/food_fastfood.77c0ca539fe68d4e85ac088cf6e4e169.png";